import { UserStatusEnum } from 'common/constants/enum';
import useTranslation from 'next-translate/useTranslation';
import { useFormContext, useWatch } from 'react-hook-form';

import CustomerSnackBar from './customer-snack-bar';

export default function CustomerSalesWarningToast() {
  const { t } = useTranslation();
  const { control } = useFormContext();
  const [hasDueReceivable, customerStatus, isExceedingQuota] = useWatch({
    control,
    name: ['hasDueReceivable', 'customerStatus', 'isExceedingQuota'],
  });
  return (
    <>
      {hasDueReceivable && (
        <CustomerSnackBar text={t('common:customer_due_receivable_message')} />
      )}
      {customerStatus === UserStatusEnum.UnderSurveillance && (
        <CustomerSnackBar text={t('common:customer_suspend_message')} />
      )}
      {isExceedingQuota && (
        <CustomerSnackBar
          text={t('common:customer_limited_transaction_message')}
        />
      )}
    </>
  );
}
